module.exports = __webpack_public_path__ + "static/media/FSTW.615bfab8.svg";